import { FormControlLabel, Radio } from '@mui/material';
import React from 'react';

export const MyMRadio = (props) => {
  const { value, label, ...other } = props;
  return (
    <FormControlLabel value={value} control={<Radio />} label={label} {...other} />
  )
}